
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { validateToken } from './modules/login/reducers';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { BreadcrumbProvider } from './context/BreadcrumbContext';
import { LoaderProvider } from './contexts/LoaderContext';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme, muiTheme } from './utils/theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const onBeforeLift = () => {
  store.dispatch(validateToken());
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor} onBeforeLift={onBeforeLift}>
        <MuiThemeProvider theme={muiTheme}>
          <StyledThemeProvider theme={theme}>
            <LoaderProvider>
              <BreadcrumbProvider>
                <RouterProvider router={router} />
              </BreadcrumbProvider>
            </LoaderProvider>
          </StyledThemeProvider>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to a analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

